import image1 from '../images/memberships/Enmascarar grupo 7.png';
import image2 from '../images/memberships/Enmascarar grupo 6.png';
import image3 from '../images/memberships/Enmascarar grupo 5.png';
import image4 from '../images/memberships/Enmascarar grupo 4.png';

import first from '../images/memberships/first.png';
import diamond from '../images/memberships/diamond.png';

const memberships = [
	{
		id: 0,
		tag: 'atsuko',
		image: image1,
		icon: first,
		title: 'Personaje Orco',
		prices: [
			{
				price: '1.390.769 COP',
			},
			{
				price: '1.344 SOLES',
			},
			{
				price: '331 Euros',
			},
			{
				price: '320.766 ARS',
			},
			{
				price: '5.985 MXN',
			},
			{
				price: '599 USD',
			},
		],
		priceUSD: '599 USD',
		price_before: {
			CO: '1.763.124 COP',
			PE: '1.710 SOLES',
			EC: '450 USD',
			ES: '421 Euros',
			AR: '407.770 ARS',
			MX: '7.761 MXN',
			ALL: '949 USD',
		},
		items: [
			{
				item: 'Feedback en vivo.',
			},
			{
				item: 'Duración 3 meses.',
			},
			{
				item: 'Grabación de clases.',
			},
			{
				item: 'Acceso un año.',
			},
			{
				item: 'Certificado.',
			},
			// {
			// 	item: 'Acceso por módulos.',
			// 	more: 'El contenido del curso de Atsuko se irá liberando por partes a medida que vayas pagando las cuotas.',
			// },
			// {
			// 	item: 'Acceso por un año al contenido.',
			// 	more: 'El año de acceso se empieza a contar a partir de la activación del primer contenido. Te recomendamos revisar los términos y condiciones de financiación.',
			// },
		],
		urls: [
			{
				name: 'Pagar con PayPal',
				class: 'paypal',
				url: 'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTU5OSZpZD1QZXJzb25hamUgZW4gWkJydXNoIHBhcmEgY2luZW3hdGljYXMgLSBPcmNvIC0gUFc=	',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
			{
				name: 'Pagar con Tarjeta',
				class: 'card',
				url: 'https://checkout.wompi.co/l/0wb1gz',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
		],
	},
	{
		id: 1,
		tag: 'atsuko',
		image: image2,
		icon: diamond,
		title: 'Master completo',
		prices: [
			{
				price: '1.991.236 COP',
			},
			{
				price: '1.924 SOLES',
			},
			{
				price: '473 Euros',
			},
			{
				price: '459.261 ARS',
			},
			{
				price: '8.566 MXN',
			},
			{
				price: '849 USD',
			},
		],
		priceUSD: '849 USD',
		price_before: {
			CO: '2.729.749 COP',
			PE: '2.648 SOLES',
			EC: '700 USD',
			ES: '652 Euros',
			AR: '631.355 ARS',
			MX: '12.015 MXN',
			ALL: '1.250 USD',
		},
		items: [
			{
				item: 'Feedback en vivo.',
			},
			{
				item: 'Duración 8 meses.',
			},
			{
				item: 'Grabación de clases.',
			},
			{
				item: 'Acceso un año + 4 meses.',
			},
			{
				item: 'Certificado.',
			},
			{
				item: 'Material premium.',
			},
			// {
			// 	item: 'Acceso al curso de Atsuko',
			// 	more: 'Tendrás a tu disposición únicamente el contenido del curso de Atsuko.',
			// },
			// {
			// 	item: 'Acceso por un año al contenido.',
			// 	more: 'El año de acceso se empieza a contar a partir de la activación del contenido en tu cuenta..',
			// },
		],
		urls: [
			{
				name: 'Pagar con PayPal',
				class: 'paypal',
				url: 'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTg0OSZpZD1N4XN0ZXIgZW4gWkJydXNoIHBhcmEgY2luZW3hdGljYXMgLSBPcmNvIC0gUFc=',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
			{
				name: 'Pagar con Tarjeta',
				class: 'card',
				url: 'https://checkout.wompi.co/l/amZ74c',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
		],
	},
];

export default memberships;
